// Megamenu on hover script
const e=document.querySelectorAll(".mega-menu"),t=document.querySelector("header");let n;e.forEach((o,r)=>{const s=o.querySelector(".mega-menu__content");o.addEventListener("mouseover",()=>{null!=n&&n!==r&&e[n].removeAttribute("open"),n=r,o.setAttribute("open",!0)}),o.addEventListener("mouseleave",i=>{let l=!0;const a=setTimeout(()=>{l&&o.removeAttribute("open")},500);s.addEventListener("mouseover",()=>{l=!1}),o.addEventListener("mouseover",()=>{clearTimeout(a)})}),s.addEventListener("mouseleave",()=>{o.removeAttribute("open")})});

document.addEventListener('DOMContentLoaded', function() {
    function updateHeaderQuantity() {
        const targetNodeText = document.querySelector('.totals__total-value')?.textContent;
        const headerCartTotal = document.querySelector('.header-cart__total');
        
        if (headerCartTotal && targetNodeText) {
            //console.log('Value updated:', targetNodeText);
            headerCartTotal.textContent = targetNodeText;
            
            const totalValue = parseFloat(targetNodeText.replace(/[^\d.-]/g, ''));
            //console.log(totalValue);
            const checkoutButton = document.querySelector('.header-checkout');
            if (totalValue > 0) {
                checkoutButton.classList.add('active-header-checkout');
            } else {
                checkoutButton.classList.remove('active-header-checkout');
            }
        }
    }

    // Set up an observer for the cart drawer if it exists
    const cartDrawer = document.querySelector('#CartDrawer');
    if (cartDrawer) {
        const observer = new MutationObserver(function() {
            updateHeaderQuantity();
        });

        observer.observe(cartDrawer, { childList: true, subtree: true, characterData: true });
        //console.log('Observer attached to cart drawer for changes.');
    }

    // Also call updateHeaderQuantity initially in case the page loads with items in the cart
    updateHeaderQuantity();
});



    function changeCurrency() {
        var selectedCurrency = document.getElementById('currencySelector').value;
        Currency.convertAll(Currency.currentCurrency, selectedCurrency);
        jQuery.cookie('currency', selectedCurrency, { expires: 7, path: '/' });
        location.reload();
    }

 
    

// document.addEventListener('DOMContentLoaded', function () {
//     var sizeGuideToggle = document.querySelector('.size-guide__toggle');
//     var modalOverlay = document.querySelector('.modal-overlay');
//     var sizeGuideModal = document.querySelector('.size-guide_modal');

//     // Function to show the modal with fade-in effect
//     function showModal() {
//         modalOverlay.style.display = 'flex'; // Use flex to center the modal
//         setTimeout(() => {
//             modalOverlay.classList.add('modal-visible'); // Trigger the fade-in effect
//         }, 10); // Short timeout ensures the display change has taken effect
//     }

//     // Function to hide the modal
//     function hideModal() {
//         modalOverlay.classList.remove('modal-visible');
//         setTimeout(() => {
//             modalOverlay.style.display = 'none';
//         }, 400); // Match the timeout to the CSS transition duration
//     }

//     // Event listener for the size guide toggle
//     sizeGuideToggle.addEventListener('click', function() {
//         showModal();
//     });

//     // Event listener for clicking outside the modal to close it
//     modalOverlay.addEventListener('click', function(event) {
//         if (event.target === modalOverlay) { // Ensure the modal itself isn't the target
//             hideModal();
//         }
//     });
// });
